/**
 * Pure helpers for GST / ITC percentage validation in claim flows.
 * @module claims/claimItcPercentage
 */

/**
 * Parses a 1–100 **whole-number** ITC percentage from user input.
 * Only non-empty strings of ASCII digits are accepted (rejects scientific notation, signs, decimals).
 * @param raw - Raw field value
 * @returns Integer 1–100, or `null` if empty or not a valid digit-only whole number in range
 */
export function parseClaimItcPercentage(raw: string): number | null {
  const t = raw.trim()
  if (t === '') return null
  if (!/^\d+$/.test(t)) return null
  const n = Number(t)
  if (!Number.isFinite(n) || !Number.isInteger(n) || n < 1 || n > 100) return null
  return n
}

/**
 * Whether GST/ITC answers are complete enough to allow submit (GST required; ITC chain when GST is Yes).
 */
export function isClaimGstItcBlockComplete(
  gstAnswer: 'Yes' | 'No' | null,
  itcAnswer: 'Yes' | 'No' | null,
  itcPctParsed: number | null
): boolean {
  if (gstAnswer === null) return false
  if (gstAnswer === 'No') return true
  if (itcAnswer === null) return false
  if (itcAnswer === 'No') return true
  return itcPctParsed !== null
}
